import { FC, useRef } from "react";
import ModalComponent from "src/core/components/modal/modal.component";
import { B2Button } from "@hdb/biome-2";


interface AssetImportModalComponentProps {
    showImportModal: boolean;
    setShowImportModal: (show: boolean) => void;
    setImportedFile: (file: File | null) => void;
    importType: "complete" | "incremental";
    setImportType: (type: "complete" | "incremental") => void;
    importedFile: File | null;
    removeModalFile: () => void;
    confirmImport: () => void;
    handleModalFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AssetImportModalComponent: FC<AssetImportModalComponentProps> = ({
    showImportModal, setShowImportModal, setImportedFile, importType, setImportType, importedFile, removeModalFile, confirmImport, handleModalFileChange
}) => {
    const handleCloseModal = () => {
        setShowImportModal(false);
        setImportedFile(null);
    }

    const fileInputRef = useRef<HTMLInputElement>(null);
    const modalActionConfig: any = [
        {
            label: "Upload",
            event: confirmImport,
            variant: "primary",
            disabled: !importedFile || !importType,
        },
    ]

    return (
        <div>
            {showImportModal && (
                <ModalComponent
                    showModal={showImportModal}
                    handleClose={handleCloseModal}
                    headerTitle={"Import Asset"}
                    actionConfig={modalActionConfig}
                    size="lg"
                >
                    <div>
                        <div style={{ padding: 16 }}>
                            <div style={{ marginBottom: 12 }}>
                                <div style={{ display: "block", fontWeight: 600, marginBottom: 8 }}>
                                    What does this file contain?
                                </div>

                                <div className="d-flex gap-3">
                                    <label className="card p-3 w-100" htmlFor="complete-import-type" aria-label="Complete master data">
                                        <div className="d-flex">
                                            <div>
                                                <input
                                                    id="complete-import-type"
                                                    type="radio"
                                                    name="importType"
                                                    checked={importType === "complete"}
                                                    onChange={() => setImportType("complete")}
                                                    className="me-2"
                                                />
                                            </div>
                                            <div>
                                                <div>Complete master data</div>
                                                <div className="text-muted small">Assets across an entire site (all blocks)</div>
                                            </div>
                                        </div>
                                    </label>

                                    <label className="card p-3 w-100" htmlFor="incremental-import-type" aria-label="Incremental master data">
                                        <div className="flex">
                                            <div>
                                                <input
                                                    id="incremental-import-type"
                                                    type="radio"
                                                    name="importType"
                                                    checked={importType === "incremental"}
                                                    onChange={() => setImportType("incremental")}
                                                    className="me-2"
                                                />
                                            </div>
                                            <div>
                                                <div>Incremental master data</div>
                                                <div className="text-muted small">Assets for a single block within a site</div>
                                            </div>
                                        </div>

                                    </label>
                                </div>
                            </div>

                            <div className="mt-5">
                                <div style={{ fontWeight: 600, display: "block", marginBottom: 8 }}>Selected file</div>
                                {importedFile ? (
                                    <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                                        <div>
                                            <strong>{importedFile?.name}</strong>
                                            <div className="small text-muted">{(importedFile?.size / 1024 / 1024).toFixed(2)} MB</div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <B2Button variant="outline-secondary" onClick={removeModalFile}>
                                                Remove
                                            </B2Button>
                                            <B2Button variant="primary" onClick={() => fileInputRef.current?.click()}>
                                                Replace
                                            </B2Button>
                                            <input type="file" accept=".xls,.xlsx" onChange={handleModalFileChange} hidden ref={fileInputRef} />
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <label className="btn btn-primary mb-0">
                                            Select file<input type="file" accept=".xls,.xlsx" onChange={handleModalFileChange} hidden />
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </ModalComponent>
            )}
        </div>
    );
};

export default AssetImportModalComponent;
